export default "__VITE_ASSET__9becc563__"